import { AvailableLanguages } from '@repo/toolkit/language-types'

export function getLocalizedLabel<T>(
  record: T,
  lang: AvailableLanguages,
  fieldMap: Record<string, keyof T>
): string {
  return (
    String(record[fieldMap[lang]] ?? '') ||
    String(record[fieldMap.fr] ?? '') ||
    Object.values(fieldMap)
      .map((k) => String(record[k] ?? ''))
      .find((value) => value) ||
    '—'
  )
}
